import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustSection from './components/TrustSection';
import FeaturedCategories from './components/FeaturedCategories';
import CategoriesGrid from './components/CategoriesGrid';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuyfinds.study';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'Kakobuy Finds',
      description: 'Największa niezależna polska baza Kakobuy Spreadsheet — aktualne listy produktów, porównania platform i przewodniki zakupowe.',
      inLanguage: 'pl-PL',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${siteUrl}/?search={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'Kakobuy Finds',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
        width: 256,
        height: 256,
      },
      sameAs: [
        'https://kaspreadsheet.com',
      ],
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'Kakobuy Spreadsheet 2026 – Polska Baza Produktów, Okazji i Przewodników Zakupowych',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      datePublished: '2026-07-07',
      dateModified: '2026-07-07',
      inLanguage: 'pl-PL',
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <TrustSection />
        <FeaturedCategories />
        <CategoriesGrid />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}